export class ConferenceCardModel {
  id: string = ''
  name?: string = ''
  language?: string = ''
  days?: number = 0
  dateApplication?: string = ''
  dateFrom?: string = ''
  dateTo?: string = ''
  location?: string = ''
}
